export default __webpack_public_path__ + "static/media/image 17.c9e880c7.png";